import { postRequest } from '@/core';
import { trips } from '@/requests';

export default async function sendTripRequest(tripId) {
	let url = trips.getSendPath(tripId);
	let response = await postRequest(url, {}, tripId);
	return response;
}
